var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9369 77C74.9369 41.4527 74.9369 12.1755 74.9369 8.33636C74.9369 8.1114 74.7325 7.95645 74.5178 8.02336C63.3534 11.5016 54.822 50.2227 54.822 77C54.822 103.803 62.5149 142.572 74.5206 145.986C74.7348 146.047 74.9369 145.892 74.9369 145.67C74.9369 141.856 74.9369 112.566 74.9369 77Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8808 76.1257C49.8808 39.9952 62.4266 12.6945 63.7595 9.89601C63.8153 9.77894 63.7284 9.65958 63.5989 9.66606C51.9431 10.2492 30.6405 47.4918 30.6405 76.1257C30.6405 104.752 51.9313 143.702 63.5892 144.334C63.7211 144.341 63.8059 144.212 63.746 144.094C62.3444 141.341 49.8808 115.744 49.8808 76.1257Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0222 76.1319C26.0222 40.6185 46.4767 18.1813 49.3115 15.2422C49.4246 15.125 49.3354 14.9376 49.1736 14.9568C36.6813 16.4381 8.53162 42.4463 8.53162 76.1319C8.53162 109.846 33.3113 135.015 49.0866 138.97C49.2541 139.012 49.3782 138.821 49.2629 138.693C46.2514 135.333 26.0222 111.449 26.0222 76.1319Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7731 77C79.7731 41.4527 79.7731 12.1755 79.7731 8.33637C79.7731 8.1114 79.9774 7.95645 80.1922 8.02337C91.3566 11.5016 99.8879 50.2227 99.8879 77C99.8879 103.803 92.195 142.572 80.1894 145.986C79.9751 146.047 79.7731 145.892 79.7731 145.67C79.7731 141.856 79.7731 112.566 79.7731 77Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.692 76.1257C104.692 39.9952 92.1458 12.6945 90.8129 9.89601C90.7571 9.77894 90.844 9.65958 90.9735 9.66606C102.629 10.2492 123.932 47.4918 123.932 76.1257C123.932 104.752 102.641 143.702 90.9832 144.334C90.8513 144.341 90.7664 144.212 90.8263 144.094C92.228 141.341 104.692 115.744 104.692 76.1257Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.739 76.1319C128.739 40.6185 108.285 18.1813 105.45 15.2422C105.337 15.125 105.426 14.9376 105.588 14.9568C118.08 16.4381 146.23 42.4463 146.23 76.1319C146.23 109.846 121.45 135.015 105.675 138.97C105.507 139.012 105.383 138.821 105.498 138.693C108.51 135.333 128.739 111.449 128.739 76.1319Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.03284334ab2831bc8ed8501904676054.svg";
export { ForwardRef as ReactComponent };